module.exports = __webpack_public_path__ + "a94f1668408ff59e61fa99b286abbe50.png";